/**
 * Completion → color, as discrete bands (warm → green). Used for the overall trip
 * progress bar (header) and the per-list right-edge accent so "done" reads green
 * at a glance everywhere. Deliberately red-free and blue-free: red reads as an
 * error and blue/teal would blend into the app's teal chrome.
 */

/** Percentage (0–100) → band color. */
export function progressColor(pct: number): string {
  if (pct >= 100) return '#15803d'; // done — bold green
  if (pct >= 80) return '#4ade80'; // almost — light green
  if (pct >= 50) return '#84cc16'; // over half — lime
  if (pct >= 1) return '#f59e0b'; // going — amber
  return '#cbd5e1'; // not started — faint grey
}

/** done/total → integer percentage (0 when empty). */
export function progressPct(done: number, total: number): number {
  return total > 0 ? Math.round((done / total) * 100) : 0;
}
